import axios from 'axios';

let ip = process.env.REACT_APP_BRING_API_URL;

// const headers: any = {
//   'Access-Control-Allow-Credentials': true,
//   Authorization: 'c60aa6f84c393ef4ea99c1b7de41c0d799344e79d9ad2267d7e37282ce8379a8',
// };

export const rootPath = ip + '';

const bringApi = axios.create({
  baseURL: rootPath,
  //headers: headers,
});

bringApi.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error: any) {
    if (error && error.response && error.response.status === 401) {
      console.log(error);
    }
    return Promise.reject(error);
  },
);

export default bringApi;
